import Vue from "vue";
import VueI18n from "vue-i18n";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from "./App.vue";
import router from "./router";
import zh from './utils/lang/config/zh'
import en from './utils/lang/config/en'
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale :'zh',
  messages:{
    zh,
    en
  },
})
new Vue({
  router,
  i18n,
  render: (h) => h(App)
}).$mount("#app");
